// removed by extract-text-webpack-plugin
module.exports = {"row":"_3YVrW8MC1wKaD6nX0IaQaq","title":"_1RAAeZ3mrxtzZZTEKZMVmO","field":"_1lQGhnEEkWfkuTR0W1hEEU","count":"_1IKGtSG1yGQXD2XSh9tSl8"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/RawMaterialMove/style.scss
// module id = 1051
// module chunks = 0